
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import AboutSection from './components/AboutSection';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Service from './pages/Service';
import OurFleets from './pages/OurFleets.';
import Packages from './pages/Packages';
import OurNetwork from './pages/OurNetwork';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import Career from './components/Career';
import ContactSection from './pages/ContactSection';
import Punedarshancab from './pages/Pune Darshan Cab';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Pimprichichwadtobhimashankarcab from './pages/Pimpri Chinchwad to Bhimashankar Cab';
import ScrollToTop from './components/ScrollToTop';
import Punetojejuricab from './pages/Pune to Jejuri Cab';
import Puneweekendtourpackage from './pages/Pune Weekend Tour Packages';
import Punedarshanpackage from './pages/Pune Darshan Packages';
import Punesadeteenshaktipeeth from './pages/Pune Sade Teen Shakti Peeth Bus on Rent';
import Punedarshantempotraveller from './pages/Pune Darshan Tempo Traveller on Rent';
import Punetomysoreootycab from './pages/Pune to Mysore Ooty Cab Package';
import Punetomumbaidarshanpackages from './pages/Pune to Mumbai Darshan Package';
import Punetoajantaellorecab from './pages/Pune to Ajanta Ellora Cab Service';
import Punetoshirdidarshanpackage from './pages/Pune to Shirdi Darshan Package';
import Punetopandharpurdarshan from './pages/Pune to Pandharpur Darshan';
import Hinjewadicabservice from './pages/Hinjewadi Cab Service';
import Cabserviceinwakad from './pages/Cab Service in Wakad';
import Cabserviceinbanerpune from './pages/Cab Service in Baner Pune';
import Cabserviceinkharadi from './pages/Cab Service in Kharadi';
import Cabserviceinhadapsar from './pages/Cab Service in Hadapsar';
import Cabserviceinvimannagar from './pages/Cab Service in Viman Nagar';
import Cabserviceinkothrud from './pages/Cab Service in Kothrud';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Cabserviceinwagholipune from './pages/Cab Service in Wagholi Pune';
import Punetrimbkeshwarcab from './pages/Pune to Trimbakeshwar Cab';
import Cabserviceinpune from './pages/Cab Service in Pune';
import Outstationtaxiservicepune from './pages/Outstation Taxi Service Pune';
import Cheapcabinpune from './pages/Cheap Cabs in Pune';
import Punecabfare from './pages/Pune Cab Fare';
import Corporatecabservicepune from './pages/Corporate Cab Service Pune';
import Puneairportcab from './pages/Pune Airport Cabs';
import Punerailwaystationcabservice from './pages/Pune Railway Station Cab Service';
import Puneonewaycabservice from './pages/Pune One Way Cab Service';
import Punelocalandoutstaioncab from './pages/Pune Local and Outstation Cab';
import Punetomumbaicab from './pages/Pune to Mumbai Cabs';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import Punetonashikcabservice from './pages/Pune to Nashik Cab Service';
import Punetonagpurcab from './pages/Pune to Nagpur Cab';
import Punetovidharbhcabservice from './pages/Pune to Vidarbha Cab Service';
import Punetokolhapurcab from './pages/Pune to Kolhapur Cab';
import Punetosolapurcabservice from './pages/Pune to Solapur Cab Service';
import Punetoahmednagartaxi from './pages/Pune to Ahmednagar Taxi';
import Punetosnglicab from './pages/Pune to Sangli Cab';
import Punetojalgaoncab from './pages/Pune to Jalgaon Cab Service';
import Punnetothanecab from './pages/Pune to Thane Cab';
import Punetopanvelcab from './pages/Pune to Panvel Cab';
import Punetohyderabadcab from './pages/Pune to Hyderabad Cab';
import Punetogoacabservice from './pages/Pune to Goa Cab Service';
import Punetosambhajinagaraurangabadcab from './pages/Pune to Sambhaji Nagar Aurangabad Cab';
import Punetogrishneshwarcab from './pages/Pune to Grishneshwar Cab';
import Punetonandedcabservice from './pages/Pune to Nanded Cab Service';
import Punetoindorecab from './pages/Pune to Indore Cab';
import Punetoujjainacab from './pages/Pune to Ujjain Cab';
import Punwetosuratccab from './pages/Pune to Surat Cab';
import Punetoahmedabadcab from './pages/Pune to Ahmedabad Cab';
import Punetolonavalacab from './pages/Pune to Lonavala Cab';
import Punetomatherantaxiservice from './pages/Pune to Matheran Taxi Service';
import Punetomahabaleshwartaxi from './pages/Pune to Mahabaleshwar Taxi';
import Punetoigatpuri from './pages/Pune to Igatpuri Taxi';
import Punetobaglorecab from './pages/Pune to Bangalore Cab';
import Punetoayodhyatourpackge from './pages/Pune to Ayodhya Tour Package';
import Punetotamhinighatcab from './pages/Pune to Tamhini Ghat Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Cabbookinginpune from './pages/Cab Booking in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Onlinecabbookinginpcmcpune from './pages/Online Cab Booking in PCMC Pune';
import Puneoutstationcabservice from './pages/Pune Outstation Cab Service';
import Punetaxiservice from './pages/Pune Taxi Service';
import Punecabbooking from './pages/Pune Cab Booking';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Punetoashtavinayakdarshancab from './pages/Pune to Ashtavinayak Darshan Cab';
import Punetopandhartuljapurcab from './pages/Pune to Pandharpur Tuljapur Cabs';
import Punetoakkalkotcabservice from './pages/Pune to Akkalkot Cab Service';
import Punetoshanishingnapurcab from './pages/Pune to Shani Shingnapur Cab';
import Punetoshegaoncab from './pages/Pune to Shegaon Cab';
import Punetoganpatipune from './pages/Pune to Ganpatipule Taxi';
import Punetokonkandarshancab from './pages/Pune to Konkan Darshan Cab';
import Punetoalibaugcab from './pages/Pune to Alibag Cab';
import Punetosindudargcabservice from './pages/Pune to Sindhudurg Cab Service';
import Punetoharihareshwarcab from './pages/Pune to Harihareshwar Cabs';
import Punetodivegarcab from './pages/Pune to Diveagar Cabs';
import Punetodapolicab from './pages/Pune to Dapoli Cab';
import Punetoguhgaecab from './pages/Pune to Guhagar Cabs';
import Punetomalvanncabservice from './pages/Pune to Malvan Cab Service';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import Punetomahabaleshwartempotraveller from './pages/Pune to Mahabaleshwar Tempo Traveller';
import Punetooutstationtempotraveller from './pages/Pune to Outstation Tempo Traveller';
import Outstationminibusonrent from './pages/Outstation Mini Bus on Rent Pune';
import Onefourseatertempotraveller from './pages/14 Seater Tempo Traveller on Rent';
import Onesevanbusonrent from './pages/17 Seater Bus on Rent Pune';
import Punetoshirditempotraveller from './pages/Pune to Shirdi Tempo Traveller';
import Luxuryforceurbaniaonrent from './pages/Luxury Force Urbania On Rent in Pune';
import Forceurbanialuxuryminibusonrent from './pages/Force Urbania Luxury Mini Bus On Rent';
import Urbaniaonrentpune from './pages/Urbania On Rent Pune';
import Urbaniaonrentinpimprichichwad from './pages/Urbania on Rent in Pimpri Chinchwad';
import Punetofivejyotilingacab from './pages/Pune to 5 Jyotirlinga Cab Package';
import Punetokhatushyamtour from './pages/Pune to Khatu Shyam Tour Package';
import Punetojaislamertourpackage from './pages/Pune to Jaisalmer Tour Package';
import Innnovaonrentinpune from './pages/Innova On Rent in Pune';
import Puneairportcabservice from './pages/Pune Airport Cab Service';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Sedancabsbookinginpune from './pages/Sedan Cabs Booking in Pune';
import Sevanseatercaronrent from './pages/7 Seater Car on Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Punetopanchganicab from './pages/Pune to Panchgani Cab';
import Rumioncarhire from './pages/Rumion Car Hire in Pune';
import Kiacarenceonrentinpune from './pages/Kia Carens On Rent in Pune';
import Multiseaterbuses from './pages/32,35,40,45,50 Seater Bus on Rent in Pune';
import Punetomumbaiinternatinal from './pages/Pune to Mumbai International Airport Cab';
import ContactButtons from './components/ContactButtons';
import Enquiry from './pages/Enquiry';
import RisingCabPayment from './pages/RisingCabPayment ';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";


function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Service />} />
        <Route path="/services" element={<RisingCabPayment />} />
        <Route path="/our-fleet" element={<OurFleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/our-network" element={<OurNetwork />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career" element={<Service />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<ContactSection />} />



<Route path="/Pune-Darshan-Cab" element={<Punedarshancab />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pimpri-Chinchwad-to-Bhimashankar-Cab" element={<Pimprichichwadtobhimashankarcab />} />
<Route path="/Pune-to-Jejuri-Cab" element={<Punetojejuricab />} />
<Route path="/Pune-Weekend-Tour-Packages" element={<Puneweekendtourpackage />} />
<Route path="/Pune-Darshan-Packages" element={<Punedarshanpackage />} />
<Route path="/Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" element={<Punesadeteenshaktipeeth />} />
<Route path="/Pune-Darshan-Tempo-Traveller-on-Rent" element={<Punedarshantempotraveller />} />
<Route path="/Pune-to-Mysore-Ooty-Cab-Package" element={<Punetomysoreootycab />} />
<Route path="/Pune-to-Mumbai-Darshan-Package" element={<Punetomumbaidarshanpackages />} />
<Route path="/Pune-to-Ajanta-Ellora-Cab-Service" element={<Punetoajantaellorecab />} />
<Route path="/Pune-to-Shirdi-Darshan-Package" element={<Punetoshirdidarshanpackage />} />
<Route path="/Pune-to-Pandharpur-Darshan" element={<Punetopandharpurdarshan />} />
<Route path="/Hinjewadi-Cab-Service" element={<Hinjewadicabservice />} />
<Route path="/Cab-Service-in-Wakad" element={<Cabserviceinwakad />} />
<Route path="/Cab-Service-in-Baner-Pune" element={<Cabserviceinbanerpune />} />
<Route path="/Cab-Service-in-Kharadi" element={<Cabserviceinkharadi />} />
<Route path="/Cab-Service-in-Hadapsar" element={<Cabserviceinhadapsar />} />
<Route path="/Cab-Service-in-Viman-Nagar" element={<Cabserviceinvimannagar />} />
<Route path="/Cab-Service-in-Kothrud" element={<Cabserviceinkothrud />} />
<Route path="/Cab-Service-in-Pimpri-Chinchwad" element={<Cabserviceinpimprichichwad />} />
<Route path="/Cab-Service-in-Wagholi-Pune" element={<Cabserviceinwagholipune />} />
<Route path="/Pune-to-Trimbakeshwar-Cab" element={<Punetrimbkeshwarcab />} />
<Route path="/Cab-Service-in-Pune" element={<Cabserviceinpune />} />
<Route path="/Outstation-Taxi-Service-Pune" element={<Outstationtaxiservicepune />} />
<Route path="/Cheap-Cabs-in-Pune" element={<Cheapcabinpune />} />
<Route path="/Pune-Cab-Fare" element={<Punecabfare />} />
<Route path="/Corporate-Cab-Service-Pune" element={<Corporatecabservicepune />} />
<Route path="/Pune-Airport-Cabs" element={<Puneairportcab />} />
<Route path="/Pune-Railway-Station-Cab-Service" element={<Punerailwaystationcabservice />} />
<Route path="/Pune-One-Way-Cab-Service" element={<Puneonewaycabservice />} />
<Route path="/Pune-Local-and-Outstation-Cab" element={<Punelocalandoutstaioncab />} />
<Route path="/Pune-to-Mumbai-Cabs" element={<Punetomumbaicab />} />
<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-to-Nashik-Cab-Service" element={<Punetonashikcabservice />} />
<Route path="/Pune-to-Nagpur-Cab" element={<Punetonagpurcab />} />
<Route path="/Pune-to-Vidarbha-Cab-Service" element={<Punetovidharbhcabservice />} />

<Route path="/Pune-to-Kolhapur-Cab" element={<Punetokolhapurcab />} />
<Route path="/Pune-to-Solapur-Cab-Service" element={<Punetosolapurcabservice />} />
<Route path="/Pune-to-Ahmednagar-Taxi" element={<Punetoahmednagartaxi />} />
<Route path="/Pune-to-Sangli-Cab" element={<Punetosnglicab />} />
<Route path="/Pune-to-Jalgaon-Cab-Service" element={<Punetojalgaoncab />} />
<Route path="/Pune-to-Thane-Cab" element={<Punnetothanecab />} />
<Route path="/Pune-to-Panvel-Cab" element={<Punetopanvelcab />} />
<Route path="/Pune-to-Hyderabad-Cab" element={<Punetohyderabadcab />} />
<Route path="/Pune-to-Goa-Cab-Service" element={<Punetogoacabservice />} />
<Route path="/Pune-to-Sambhaji-Nagar-Aurangabad-Cab" element={<Punetosambhajinagaraurangabadcab />} />
<Route path="/Pune-to-Grishneshwar-Cab" element={<Punetogrishneshwarcab />} />
<Route path="/Pune-to-Nanded-Cab-Service" element={<Punetonandedcabservice />} />
<Route path="/Pune-to-Indore-Cab" element={<Punetoindorecab />} />
<Route path="/Pune-to-Ujjain-Cab" element={<Punetoujjainacab />} />
<Route path="/Pune-to-Surat-Cab" element={<Punwetosuratccab />} />
<Route path="/Pune-to-Ahmedabad-Cab" element={<Punetoahmedabadcab />} />
<Route path="/Pune-to-Lonavala-Cab" element={<Punetolonavalacab />} />
<Route path="/Pune-to-Matheran-Taxi-Service" element={<Punetomatherantaxiservice />} />
<Route path="/Pune-to-Mahabaleshwar-Taxi" element={<Punetomahabaleshwartaxi />} />
<Route path="/Pune-to-Igatpuri-Taxi" element={<Punetoigatpuri />} />
<Route path="/Pune-to-Bangalore-Cab" element={<Punetobaglorecab />} />
<Route path="/Pune-to-Ayodhya-Tour-Package" element={<Punetoayodhyatourpackge />} />
<Route path="/Pune-to-Tamhini-Ghat-Cab" element={<Punetotamhinighatcab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Cab-Booking-in-Pune" element={<Cabbookinginpune />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookingpune />} />
<Route path="/Online-Cab-Booking-in-PCMC-Pune" element={<Onlinecabbookinginpcmcpune />} />
<Route path="/Pune-Outstation-Cab-Service" element={<Puneoutstationcabservice />} />
<Route path="/Pune-Taxi-Service" element={<Punetaxiservice />} />
<Route path="/Pune-Cab-Booking" element={<Punecabbooking />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-to-Ashtavinayak-Darshan-Cab" element={<Punetoashtavinayakdarshancab />} />
<Route path="/Pune-to-Pandharpur-Tuljapur-Cabs" element={<Punetopandhartuljapurcab />} />
<Route path="/Pune-to-Akkalkot-Cab-Service" element={<Punetoakkalkotcabservice />} />
<Route path="/Pune-to-Shani-Shingnapur-Cab" element={<Punetoshanishingnapurcab />} />
<Route path="/Pune-to-Shegaon-Cab" element={<Punetoshegaoncab />} />
<Route path="/Pune-to-Ganpatipule-Taxi" element={<Punetoganpatipune />} />
<Route path="/Pune-to-Konkan-Darshan-Cab" element={<Punetokonkandarshancab />} />

<Route path="/Pune-to-Alibag-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-to-Sindhudurg-Cab-Service" element={<Punetosindudargcabservice />} />
<Route path="/Pune-to-Harihareshwar-Cabs" element={<Punetoharihareshwarcab />} />
<Route path="/Pune-to-Diveagar-Cabs" element={<Punetodivegarcab />} />
<Route path="/Pune-to-Dapoli-Cab" element={<Punetodapolicab />} />
<Route path="/Pune-to-Guhagar-Cabs" element={<Punetoguhgaecab />} />
<Route path="/Pune-to-Malvan-Cab-Service" element={<Punetomalvanncabservice />} />
<Route path="/Mini-Bus-On-Rent-in-Pune" element={<Minibusonrentinpune />} />
<Route path="/Tempo-Traveller-On-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Pune-to-Mahabaleshwar-Tempo-Traveller" element={<Punetomahabaleshwartempotraveller />} />
<Route path="/Pune-to-Outstation-Tempo-Traveller" element={<Punetooutstationtempotraveller />} />
<Route path="/Outstation-Mini-Bus-on-Rent-Pune" element={<Outstationminibusonrent />} />
<Route path="/14-Seater-Tempo-Traveller-on-Rent" element={<Onefourseatertempotraveller />} />
<Route path="/17-Seater-Bus-on-Rent-Pune" element={<Onesevanbusonrent />} />
<Route path="/Pune-to-Shirdi-Tempo-Traveller" element={<Punetoshirditempotraveller />} />
<Route path="/Luxury-Force-Urbania-On-Rent-in-Pune" element={<Luxuryforceurbaniaonrent />} />
<Route path="/Force-Urbania-Luxury-Mini-Bus-On-Rent" element={<Forceurbanialuxuryminibusonrent />} />
<Route path="/Urbania-On-Rent-Pune" element={<Urbaniaonrentpune />} />
<Route path="/Urbania-on-Rent-in-Pimpri-Chinchwad" element={<Urbaniaonrentinpimprichichwad />} />
<Route path="/Pune-to-5-Jyotirlinga-Cab-Package" element={<Punetofivejyotilingacab />} />
<Route path="/Pune-to-Khatu-Shyam-Tour-Package" element={<Punetokhatushyamtour />} />
<Route path="/Pune-to-Jaisalmer-Tour-Package" element={<Punetojaislamertourpackage />} />
<Route path="/Innova-On-Rent-in-Pune" element={<Innnovaonrentinpune />} />
<Route path="/Pune-Airport-Cab-Service" element={<Puneairportcabservice />} />
<Route path="/Swift-Dzire-On-Rent-in-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Sedan-Cabs-Booking-in-Pune" element={<Sedancabsbookinginpune />} />
<Route path="/7-Seater-Car-on-Rent-in-Pune" element={<Sevanseatercaronrent />} />
<Route path="/Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Pune-to-Panchgani-Cab" element={<Punetopanchganicab />} />
<Route path="/Rumion-Car-Hire-in-Pune" element={<Rumioncarhire />} />
<Route path="/Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrentinpune />} />
<Route path="/32-35-40-45-50-Seater-Bus-on-Rent-in-Pune" element={<Multiseaterbuses />}/>
<Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternatinal />}/>


     </Routes>


<Footer/>
    </Router>
  );
}

export default App;
